import React from 'react';
import {CircleAlert} from "./alert.styles";

const Alert = ({classNames, alertClassName= 'icon-tick-circle'}) => {
    return (
        <div className={`d-inline-block ${classNames}`}>
            <CircleAlert className={alertClassName}/>
        </div>

    );
};

export default Alert;
